import Decimal from "decimal.js";
import { getProductAvailability } from "../hooks/useWorkingTime";

/**
 * Os itens da sacola no formato que as listas (ProductsListCart e
 * ProductsListCartTotem) desenham: nome com quantidade, respostas em texto e
 * os avisos de indisponível ou de preço que mudou desde que o item entrou.
 */
export default function buildCartItems(
  orders,
  {
    products,
    questionsByProduct,
    answersByOrder,
    cachedCostPerOrder,
    cachedCostPerOrderOld,
    kilogramStep,
  },
) {
  return orders.map((order) => {
    const productId = order.productId;
    const productQuestions = questionsByProduct[productId] || [];

    const detailsList = answersByOrder[order.uuid].map((a) => {
      const question = a.question;
      const label = question.options.find((o) => o.id === a.optionId).label;
      const name =
        question.pizza && question.pizzaPriceMode
          ? `${a.qtt}/${question.maxQtt} - ${label}`
          : `${a.qtt}x ${label}`;
      return {
        name,
        error: optionErrors(productQuestions, a),
      };
    });

    if (order.observations) {
      detailsList.push({
        name: `Observação: ${order.observations}`,
        error: {
          isDisabled: false,
        },
      });
    }

    const isKilogram = !!order.product.isKilogram;
    return {
      uuid: order.uuid,
      id: productId,
      price: cachedCostPerOrder[order.uuid],
      name: `${order.qtt}x ${order.product.name}`,
      productName: order.product.name,
      qtt: order.qtt,
      qttMinimum: isKilogram ? kilogramStep : 1,
      isKilogram,
      detailsList,
      deliveryVisible: order?.product?.deliveryVisible ?? false,
      pictureUrl: order.product.pictureUrl,
      error: productErrors(
        order,
        products,
        cachedCostPerOrderOld,
        cachedCostPerOrder,
      ),
    };
  });
}

function productErrors(
  order,
  products,
  cachedCostPerOrderOld,
  cachedCostPerOrder,
) {
  const product = products.find((p) => p.id === order.productId);
  if (product) {
    const isDisabled = product.disabled;
    const isAvailable = getProductAvailability(product).isAvailable;
    const priceDiff = cachedCostPerOrderOld[order.uuid]
      ? Decimal(cachedCostPerOrder[order.uuid]).minus(
          cachedCostPerOrderOld[order.uuid],
        )
      : Decimal(0);
    return {
      isDisabled: isDisabled || !isAvailable,
      isPriceChanged: !priceDiff.equals(0),
      priceDiff,
    };
  }

  return {
    isDisabled: true,
  };
}

function optionErrors(questions, answeredOption) {
  const fixedQuestion = questions.find(
    (q) => q.id === answeredOption.questionId,
  );
  if (fixedQuestion) {
    const fixedOption = fixedQuestion.options.find(
      (o) => o.id === answeredOption.optionId,
    );
    if (fixedOption) {
      return {
        isDisabled: fixedOption.disabled,
      };
    }
  }

  return {
    isDisabled: true,
  };
}
